import React from "react";

import CompletedActivityCardSkeleton from "../common/CompletedActivityCardSkeleton";

export const RESULTS_LOADING_SKELETON_COUNT = 10;

/**
 * Full-page shimmer for the results list while the initial page/permissions
 * load, mirroring the list layout so content fades in without a layout shift.
 */
function ResultsListSkeleton({ message = null, t }) {
  return (
    <div className="w-full max-w-lg h-full min-h-0 p-4 flex flex-col gap-4 overflow-hidden">
      <section className="w-full flex-1 min-h-0 flex flex-col gap-3">
        <h2 className="subtitle-text text-center">
          {t("results.title", "Results")}
        </h2>
        {message ? <p className="muted-text text-center">{message}</p> : null}
        <div className="w-full flex-1 min-h-0 overflow-hidden">
          <div className="w-full flex flex-col gap-3 pb-3">
            {Array.from({ length: RESULTS_LOADING_SKELETON_COUNT }).map(
              (_, index) => (
                <CompletedActivityCardSkeleton
                  key={index}
                  showDetails={index < 2}
                />
              ),
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ResultsListSkeleton;
